module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.error !== '') ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.menu), function(item) {
    return _c('li', [_c('a', {
      attrs: {
        "aria-expanded": true
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      class: ['fa', item.icon]
    })]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.checked),
        expression: "item.checked"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(item.checked) ? _vm._i(item.checked, null) > -1 : (item.checked)
      },
      on: {
        "change": function($event) {
          var $$a = item.checked,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(item, "checked", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(item, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(item, "checked", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(item.label || item.label) + "\n            "), (item.children && item.children.length) ? _c('span', {
      staticClass: "icon is-small is-angle"
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })]) : _vm._e()]), _vm._v(" "), (item.children && item.children.length) ? _c('expanding', [_c('ul', _vm._l((item.children), function(subItem) {
      return _c('li', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (subItem.checked),
          expression: "subItem.checked"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(subItem.checked) ? _vm._i(subItem.checked, null) > -1 : (subItem.checked)
        },
        on: {
          "change": function($event) {
            var $$a = subItem.checked,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(subItem, "checked", $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(subItem, "checked", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(subItem, "checked", $$c)
            }
          }
        }
      }), _vm._v(" " + _vm._s(subItem.label || subItem.label) + "\n              ")])
    }), 0)]) : _vm._e()], 1)
  }), 0)]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-disabled': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    class: {
      'button': true,
      'is-success': true,
      'is-disabled': _vm.errors.any(),
      'is-loading': _vm.inProgress
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2acbf2de","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/users/UserPermissions.vue
// module id = 1092
// module chunks = 39